import { render, staticRenderFns } from "./riskOrderReview.vue?vue&type=template&id=415ed7fc&scoped=true"
import script from "./riskOrderReview.vue?vue&type=script&lang=js"
export * from "./riskOrderReview.vue?vue&type=script&lang=js"
import style0 from "./riskOrderReview.vue?vue&type=style&index=0&id=415ed7fc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415ed7fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('415ed7fc')) {
      api.createRecord('415ed7fc', component.options)
    } else {
      api.reload('415ed7fc', component.options)
    }
    module.hot.accept("./riskOrderReview.vue?vue&type=template&id=415ed7fc&scoped=true", function () {
      api.rerender('415ed7fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/riskOrder/riskOrderReview.vue"
export default component.exports